function isFalsyOrPlaceholder(url) {
    return !url || url === "#";
}
function hasProtocol(url) {
    return /^[a-z][a-z0-9+.-]*:/i.test(url.trim());
}
function shouldSkipTrailingSlash(url) {
    if (hasProtocol(url)) {
        return true;
    }
    if (url.includes("?") || url.includes("#")) {
        return true;
    }
    const pathOnly = url.split("?")[0].split("#")[0];
    const lastSegment = pathOnly.slice(pathOnly.lastIndexOf("/") + 1);
    return lastSegment.includes(".");
}
function addTrailingSlashIfMissing(url) {
    return url.endsWith("/") ? url : `${url}/`;
}
export function trailingSlash(url) {
    if (isFalsyOrPlaceholder(url)) {
        return url || "#";
    }
    if (shouldSkipTrailingSlash(url)) {
        return url;
    }
    return addTrailingSlashIfMissing(url);
}
export function applyTrailingSlashToAnchorHrefs(html) {
    if (!html || typeof html !== "string") {
        return html;
    }
    return html.replace(/href=(["'])([^"']*)\1/gi, (_match, quote, hrefValue) => `href=${quote}${trailingSlash(hrefValue)}${quote}`);
}
